/** 右侧 TabPages 区域 Tab id（与 URL `?tab=`、userLastUsedScheduleTab 后缀一致） */
export type ScheduleDetailsTabType = 'currentDate' | 'scenes' | 'clipboard' | 'details';

export const SCHEDULE_DETAILS_VALID_TABS: readonly ScheduleDetailsTabType[] = [
  'currentDate',
  'scenes',
  'clipboard',
  'details',
] as const;

function isScheduleDetailsTabId(s: string): s is ScheduleDetailsTabType {
  return (SCHEDULE_DETAILS_VALID_TABS as readonly string[]).includes(s);
}

/** 解析 URL / 缓存中的 tab 片段；非法值返回 null。 */
export function parseScheduleDetailsTabId(raw: string | null | undefined): ScheduleDetailsTabType | null {
  if (!raw) return null;
  if (isScheduleDetailsTabId(raw)) return raw;
  return null;
}
